<div class="sample-clients  axs-container pad-top-2 pad-bottom-2">
  <div class="axs-container-inner-wrapper ">
    <div class=" axs-lg-offset-left-1">
      <div class="sample-clients__title text-subtitle-1 axs-side-burn">
        {{ sampleClientsContent.title }}
      </div>
      <div class="sample-clients__description">
        {{ sampleClientsContent.description }}
      </div>
      <div class="sample-clients__gallery">
        <ngx-axs-gallery
          [axsValue]="galleryActiveItem"
          [axsData]="gallerySlotData"
          [axsInfinite]="true"
          [axsControlsPosition]="'bottom'"
          [axsTransitionTime]="400"
          [axsCustomControls]="useCustomControls"
          [axsHideButtonControls]="useCustomControls"
          [axsPagination]="!useCustomControls"
          [axsLayoutMulti]="galleryMultiLayout"
          [axsGap]="galleryMultiLayout?'32px':'0'"
          (axsNext)="onNext($event)"
          (axsPrev)="onPrev($event)"
          (axsChange)="onPageChange($event)"
          (axsPaginationItemClick)="paginationClick($event)"
        >
          <ng-container axsGalleryControls>
            <div class="gallery-controls">
              <ngx-axs-button [axsType]="'icon-only'"
                              [axsIconType]="'arrowLeft'"
                              (axsClick)="prev()"
              ></ngx-axs-button>
              <div class="gallery-controls__pagination">
                <button
                  *ngFor="let pageIndex of paginationIndices"
                  [class.active]="galleryActiveItem === pageIndex"
                  (click)="paginationClick({ index: pageIndex })">
                </button>
              </div>
              <ngx-axs-button [axsType]="'icon-only'"
                              [axsIconType]="'arrowRight'"
                              (axsClick)="next()"
              ></ngx-axs-button>
            </div>
          </ng-container>
          <ng-container *ngFor="let sampleClient of sampleClientData; let i = index">
            <ngx-axs-gallery-item [slotName]="'slot'+(i+1)">
              <div class="sample-client-card">
                <div class="sample-client-card__container elevation-50"
                     [ngClass]="{'sample-client-card--active': activeClientIndex === i}">
                  <div class="active-indicator"
                       [ngClass]="{'active-indicator--enabled':activeClientIndex === i}">
                    <img ngSrc='assets/svgs/sample-client-active-icon.svg' alt="" class="active-indicator__icon"
                         width="10"
                         height="10" />
                    <div class="active-indicator__text">
                      {{ sampleClientsContent.cardLabelActive }}
                    </div>
                  </div>
                  <div class="sample-client-card__content">
                    <div class="sample-client-card__image">
                      <img src="{{sampleClient.imgPath}}" alt=""
                           class="sample-client-card__icon" />
                    </div>
                    <div class="sample-client-card__text">
                      <div [innerHTML]="sampleClient.cardText"></div>
                      <div class="sample-client-card__actions">
                        <ngx-axs-button *ngIf="activeClientIndex !== i"
                                        [axsTheme]="ButtonTheme.vgRed"
                                        [axsSize]="ButtonSize.small"
                                        [axsText]="sampleClientsContent.cardLabelCalculate"
                                        (axsClick)="useSampleClient(i)"
                        ></ngx-axs-button>
                        <ngx-axs-button
                          [axsTheme]="ButtonTheme.blackOutline"
                          [axsSize]="ButtonSize.small"
                          [axsText]="sampleClientsContent.cardLabelClientDetails"
                          (axsClick)="openSampleClientModal(sampleClient.modalData)"
                        ></ngx-axs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ngx-axs-gallery-item>
          </ng-container>
        </ngx-axs-gallery>
      </div>
    </div>
  </div>
</div>
<sample-client-modal
  [(isOpen)]="isSampleClientModalOpen"
  [modalData]="modalData"
  (loadClient)="handleLoadClient($event)"
></sample-client-modal>

